import { Container, IconButton } from "@mui/material";
import {
  createFileRoute,
  useCanGoBack,
  useRouter,
} from "@tanstack/react-router";
import { PageHeader } from "@dmca/frontend/components/nav";
import { checkPermissionsInLoader } from "@dmca/frontend/hooks";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { WeldingParameterTable } from "@dmca/frontend/widgets/welding";

export const Route = createFileRoute("/_authed/welding")({
  component: RouteComponent,
  loader: async ({ context }) => {
    const { trpcQcProxy: trpc, qc } = context;
    await checkPermissionsInLoader("WeldingParams::ViewWeldingParams", context);
    qc.prefetchQuery(trpc.weldingParams.getAll.queryOptions());
  },
  head: () => ({
    meta: [
      {
        title: "Welding Parameters | DNA Dashboard",
      },
    ],
  }),
});

function RouteComponent() {
  const router = useRouter();
  const canGoBack = useCanGoBack();

  return (
    <Container>
      <PageHeader>Welding Parameters</PageHeader>

      <WeldingParameterTable
        extraToolbarContent={
          <IconButton
            onClick={() => router.history.back()}
            disabled={!canGoBack}
          >
            <ArrowBackIcon />
          </IconButton>
        }
      />
    </Container>
  );
}
